import React, { useEffect, useState } from 'react';

const LoyaltySettings = () => {
  const [pesoPerPoint, setPesoPerPoint] = useState('');
  const [newPesoRate, setNewPesoRate] = useState('');

  const [pointsPerNsmPeso, setPointsPerNsmPeso] = useState('');
  const [newPointsRate, setNewPointsRate] = useState('');

  const [simulationMode, setSimulationMode] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch('https://loyaltyprogram.navalsupermart.com/api/get_settings.php?name=peso_per_point')
      .then(res => res.json())
      .then(data => setPesoPerPoint(data.value));

    fetch('https://loyaltyprogram.navalsupermart.com/api/get_settings.php?name=nsm_peso_per_point')
      .then(res => res.json())
      .then(data => setPointsPerNsmPeso(data.value));

    fetch('https://loyaltyprogram.navalsupermart.com/api/get_simulation_mode.php')
      .then(res => res.json())
      .then(data => setSimulationMode(data.mode));
  }, []);

  const updateSetting = (name, value, label) => {
    if (!value || isNaN(value) || Number(value) <= 0) {
      setMessage(`❌ Invalid input for ${label}.`);
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('value', value);

    fetch('https://loyaltyprogram.navalsupermart.com/api/update_settings.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setMessage(`✅ ${label} updated successfully.`);
          if (name === 'peso_per_point') setPesoPerPoint(value);
          if (name === 'nsm_peso_per_point') setPointsPerNsmPeso(value);
        } else {
          setMessage(`❌ Failed to update ${label}.`);
        }
      })
      .catch(() => setMessage(`❌ Server error on ${label}.`));
  };

  const toggleSimulation = () => {
    const newMode = simulationMode === 'enabled' ? 'disabled' : 'enabled';

    const formData = new FormData();
    formData.append('mode', newMode);

    fetch('https://loyaltyprogram.navalsupermart.com/api/toggle_simulation_mode.php', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setSimulationMode(newMode);
          setMessage(`✅ Simulation mode is now ${newMode}.`);
        } else {
          setMessage('❌ Failed to toggle simulation mode.');
        }
      })
      .catch(() => setMessage('❌ Server error when toggling simulation mode.'));
  };

  return (
    <div>
      <h2>🛠 Loyalty Settings</h2>

      <section style={{ marginBottom: '24px' }}>
        <h3>💳 Point Earning Rate</h3>
        <p><strong>Current:</strong> ₱{pesoPerPoint || 'Not Set'} = 1 point</p>
        <input
          type="number"
          value={newPesoRate}
          onChange={(e) => setNewPesoRate(e.target.value)}
          placeholder="New rate (₱ per 1 point)"
          min="1"
        />
        <button onClick={() => updateSetting('peso_per_point', newPesoRate, 'Peso per Point')}>Update</button>
      </section>

      <section style={{ marginBottom: '24px' }}>
        <h3>💰 NSM Peso Conversion</h3>
        <p><strong>Current:</strong> {pointsPerNsmPeso || 'Not Set'} points = NSM ₱1</p>
        <input
          type="number"
          value={newPointsRate}
          onChange={(e) => setNewPointsRate(e.target.value)}
          placeholder="New rate (points per NSM Peso)"
          min="1"
        />
        <button onClick={() => updateSetting('nsm_peso_per_point', newPointsRate, 'NSM Peso Conversion')}>Update</button>
      </section>

      <section>
        <h3>🧪 Simulation Mode</h3>
        <p><strong>Status:</strong> {simulationMode === 'enabled' ? '🟢 ON' : '🔴 OFF'}</p>
        <button onClick={toggleSimulation}>
          {simulationMode === 'enabled' ? 'Disable' : 'Enable'} Simulation Mode
        </button>
      </section>

      {message && <p style={{ marginTop: '1rem' }}>{message}</p>}
    </div>
  );
};

export default LoyaltySettings;
